import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api, setToken, clearToken, getToken } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) { setBusiness(null); setLoading(false); return; }
    try {
      const r = await api.get("/auth/me");
      setBusiness(r.data);
    } catch (err) {
      console.error("Auth refresh failed:", err);
      clearToken();
      setBusiness(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setToken(r.data.token);
    setBusiness(r.data.business);
    return r.data.business;
  }, []);

  const signup = useCallback(async (payload) => {
    const r = await api.post("/auth/signup", payload);
    setToken(r.data.token);
    setBusiness(r.data.business);
    return r.data.business;
  }, []);

  const logout = useCallback(() => { clearToken(); setBusiness(null); }, []);

  const value = useMemo(
    () => ({ business, setBusiness, loading, login, signup, logout, refresh }),
    [business, loading, login, signup, logout, refresh]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
